import type { EditorWarning } from "../fields/editor-warning";

export type EditorLinkKind =
  | "website"
  | "discord"
  | "github"
  | "docs"
  | "video"
  | "other";
export type EditorLink = Readonly<{
  label: string;
  url: string;
  kind: EditorLinkKind | null;
}>;
export type EditableLink = EditorLink &
  Readonly<{
    warnings: readonly EditorWarning[];
    urlError: string | null;
  }>;
export type EditorLinkChange = Readonly<{
  index: number;
  patch: Partial<EditorLink>;
}>;

export const kindOptions: readonly Readonly<{
  value: EditorLinkKind | "";
  label: string;
}>[] = [
  { value: "", label: "No kind" },
  { value: "website", label: "Website" },
  { value: "discord", label: "Discord" },
  { value: "github", label: "GitHub" },
  { value: "docs", label: "Docs" },
  { value: "video", label: "Video" },
  { value: "other", label: "Other" },
];
